<template>
  <div class="pb-3">
    <organism-qr-access-create-new
      :customerByIdc="customerByIdc"
      @createSiteAccess="createSiteAccessToApi"
      @getCustomerInfoByIdc="getCustomerInfoByIdc"
    ></organism-qr-access-create-new>
  </div>
</template>

<script>
import { getContractByIdcId } from "@/api/api-module1"
import { createNewSiteAccess } from "@/api/module-1/site-access"
import mixins from "@/mixins"
import mixinsSiteHelper from "@/mixins/mixinsSiteHelper"
import OrganismQrAccessCreateNew from "@/components/organisms/portal/internal/qrAccess/OrganismQrAccessCreateNew.vue"

export default {
  name: "QRAccessCreateNew",
  components: { OrganismQrAccessCreateNew },
  mixins: [mixins, mixinsSiteHelper],
  data() {
    return {
      // customer
      customerByIdc: {
        name: "",
        siteId: "",
        siteName: "",
      },
    }
  },
  computed: {
    isInternal() {
      return this.$route.meta.type === "internal"
    },
  },
  methods: {
    // search customer data by idc-id
    async getCustomerInfoByIdc(idcId) {
      this.showLoading(true)
      this.customerByIdc.name = ""
      this.customerByIdc.siteId = ""
      this.customerByIdc.siteName = ""

      await getContractByIdcId(idcId)
        .then(async (contract) => {
          this.customerByIdc.name = contract.customer.customerName
          this.customerByIdc.siteId = contract.siteId
          this.customerByIdc.siteName = await this.getSingleSiteNameBySiteId(
            contract.siteId
          )
        })
        .finally(() => this.showLoading(false))
    },

    async createSiteAccessToApi(requestCreateNewSiteAccess) {
      this.showLoading(true)
      await createNewSiteAccess(requestCreateNewSiteAccess, this.isInternal)
        .then((siteAccess) => {
          if (siteAccess.status === "ok") {
            this.toastSuccess("Site Access created successfully")

            this.$router.push(
              `/internal/web-portal/site-access/${siteAccess.data.siteAccessId}`
            )
          } else this.toastError("Site Access created failed")
        })
        .finally(() => this.showLoading(false))
    },
  },
}
</script>

<style lang="scss" scoped></style>
